/* eslint-disable @typescript-eslint/no-explicit-any */
export const gaEvent = (...args: any[]) => window.gaEvent && window.gaEvent(...args)

export const ga = ((...args: any[]) => {
  window?.ga && window.ga.call(window.ga, args as any)
}) as typeof window.ga
